import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-envelope",
  "use": "icon-envelope-usage",
  "viewBox": "0 0 21 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 13\" id=\"icon-envelope\"><path d=\"M.933 0C.428 0 0 .411 0 .897v11.206c0 .486.428.897.933.897h19.134c.505 0 .933-.412.933-.897V.897C21 .41 20.572 0 20.067 0H.933ZM2.53 1.345h15.94L10.5 8.069 2.53 1.345Zm-1.13.84 5.068 4.266-5.068 4.35V2.185Zm18.2 0v8.616l-5.068-4.35L19.6 2.185ZM7.525 7.348l2.516 2.122a.717.717 0 0 0 .918 0l2.516-2.122 5.024 4.307H2.501l5.024-4.307Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol